export const smallScreenLimit = '1015px'

export const tablet = '680px'
export const galaxy_Fold = '280px'
